
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktopVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1920,
  height: 224,
  viewBox: "0 0 1920 224",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2211 170.193c-15.95-41.386-233.32-37.417-308.1-35.39-363.83 9.829-761.2 50.594-1130.504 67.372-179.336 8.148-432.319 28.812-565.166-33.637C119.402 127.261 1.305 5.838-91.373-17.972c-10.97-2.807-55.386-12.978-54.617-2.147V380H2211V170.193Z",
  fill: "#13051A"
})));

      const __svgRaw = "<svg width=\"1920\" height=\"224\" viewBox=\"0 0 1920 224\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M2211 170.193C2195.05 128.807 1977.68 132.776 1902.9 134.803C1539.07 144.632 1141.7 185.397 772.396 202.175C593.06 210.323 340.077 230.987 207.23 168.538C119.402 127.261 1.30521 5.83886 -91.3732 -17.9712C-102.343 -20.7794 -146.759 -30.95 -145.99 -20.1187L-145.99 380L2211 380L2211 170.193Z\" fill=\"#13051A\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/desktop-vector.7e54def1b93a024811e97df7d038c4c6.svg"),
        {
          React: SvgDesktopVector,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      